import React from 'react';
import { ArrowIcon, Button, Typography } from 'fronton-react';
import { FilterColumn } from 'common/components';
import { NUMBER_OF_SHOWN_FILTER_ITEMS } from '../../../../../../../constants';
import { useSideFilter } from './hooks';

import { FilterListStyles, HiddenList, ShowMoreItemsBtnStyles } from './styles';

export const SideFilter = () => {
	const {
		checkboxHandler,
		selectedFilterItems,
		topCategories,
		showMoreFilterItemsBtnHandler,
		showMoreFIBtnText,
		showMoreFIBtnArrowDirection,
		isHiddenListOpen,
	} = useSideFilter();

	const firstListEnd = Math.min(topCategories.length, NUMBER_OF_SHOWN_FILTER_ITEMS);

	return (
		<div className="filter__list--wrapper">
			<Typography variant="m" size="subtitle" style={{ marginBottom: '18px' }}>
				Список услуг
			</Typography>
			<FilterColumn
				topCategories={topCategories}
				selectedFilterItems={selectedFilterItems}
				start={0}
				end={firstListEnd}
				checkboxHandler={checkboxHandler}
				className={FilterListStyles}
			/>
			{firstListEnd < topCategories.length && (
				<>
					<HiddenList isOpen={isHiddenListOpen}>
						<FilterColumn
							topCategories={topCategories}
							selectedFilterItems={selectedFilterItems}
							start={firstListEnd}
							end={topCategories.length}
							checkboxHandler={checkboxHandler}
							className={FilterListStyles}
						/>
					</HiddenList>
					<Button
						kind="regular"
						variant="pseudo"
						size="s"
						iconRight={<ArrowIcon direction={showMoreFIBtnArrowDirection} />}
						className={ShowMoreItemsBtnStyles}
						onClick={showMoreFilterItemsBtnHandler}
						data-qa="show-more-filter-items-btn"
					>
						<Typography variant="m" size="body_long">
							{showMoreFIBtnText}
						</Typography>
					</Button>
				</>
			)}
		</div>
	);
};
